import { makeActionCreator } from '../../../utilities'
import { LoaderConstants } from './loader.constants'

export const showLoader = makeActionCreator(LoaderConstants.SHOW_LOADER, 'loader')
export const hideLoader = makeActionCreator(LoaderConstants.HIDE_LOADER)
export const resetLoader = makeActionCreator(LoaderConstants.RESET_LOADER)
